import React, { useRef, useState } from "react";
import './BabylonScene.css';
import * as _ from 'lodash';
import HUDMenu from "../../react/HUD/Menu/Menu";
import World from "../World/World";
import { CameraControlsProvider } from "../../react/context/CameraControlsCallbackContext";
import HUDFps from "../../react/HUD/Fps/Fps";
import { FPSProvider } from "../../react/context/FpsContext";
import { MediaPlayerControlsProvider } from "../../react/context/MediaPlayerContext";
import HUDMediaControls from "../../react/HUD/MediaControls/MediaControls";

const BabylonScene = () => {

  return (
    <div>
      <CameraControlsProvider>
        <FPSProvider>
          <MediaPlayerControlsProvider>
            <World 
              onShouldEnableMic={async () => {}}
              onShouldEnableCamera={async () => {}}
            />
            <HUDMenu />
            <HUDFps />
            <HUDMediaControls />
          </MediaPlayerControlsProvider>
        </FPSProvider>
      </CameraControlsProvider>
    </div>
  )
};

export default BabylonScene;